import { render, staticRenderFns } from "./UnitList.vue?vue&type=template&id=6d4e4cb1&scoped=true&"
import script from "./UnitList.vue?vue&type=script&lang=js&"
export * from "./UnitList.vue?vue&type=script&lang=js&"
import style0 from "./UnitList.vue?vue&type=style&index=0&id=6d4e4cb1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4e4cb1",
  null
  
)

export default component.exports